import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import {
  Avatar,
  Button,
  IconButton,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { BASE_URL } from "../../utils/BaseURL";
import { enqueueSnackbar } from "notistack";

const Profile = () => {
  const [user, setUser] = useState({
    _id: "",
    name: "",
    email: "",
    phoneNumber: "",
    gender: "",
    country: "",
    profileImage: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));
    const id = userData.user._id;
    axios
      .get(`${BASE_URL}/users/get/${id}`)
      .then((res) => {
        if (res.data.success) {
          const item = res.data.getuser;
          setUser(() => ({
            ...user,
            _id: item?._id,
            name: item?.name,
            email: item?.email,
            phoneNumber: item?.phoneNumber,
            gender: item?.gender,
            country: item?.country,
            profileImage: item?.profileImage,
          }));
          localStorage.setItem("user", JSON.parse(item));
        } else {
          console.log(res);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setUser({
      ...user,
      [name]: value,
    });
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const formData = new FormData();
    formData.append(`images[]`, file);
    setLoading(true);
    try {
      const response = await axios.post(
        BASE_URL + "/product/get-image-array",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      let image = response?.data?.images[0];
      setUser({ ...user, profileImage: image });
    } catch (error) {
      enqueueSnackbar(`Please try again, Images upload is failed.`, {
        variant: "error",
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    // console.log(user._id)

    axios
      .patch(`${BASE_URL}/users/update/${user._id}`, user)
      .then((res) => {
        if (res.data.success) {
          console.log(res.data);
          enqueueSnackbar("User Updated Successfully", {
            variant: "success",
          });
        } else {
          enqueueSnackbar("Something went wrong", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, { variant: "error" });
      })
      .finally(() => {
        setIsEditing(false);
      });
  };

  return (
    <div className=" p-6 w-full">
      <h2 className="text-2xl font-bold mb-4 text-center">User Profile</h2>
      <div className=" mx-auto bg-white rounded  flex  justify-around  ">
        <div className="">
          <div className="mb-4 ">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Name:
            </label>
            <TextField
              size="small"
              value={user?.name}
              disabled={!isEditing}
              name="name"
              onChange={handleOnChange}
            ></TextField>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Email:
            </label>
            <TextField
              size="small"
              value={user?.email}
              disabled={!isEditing}
              name="email"
              onChange={handleOnChange}
            ></TextField>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Phone no:
            </label>
            <TextField
              size="small"
              value={user?.phoneNumber}
              disabled={!isEditing}
              name="phoneNumber"
              onChange={handleOnChange}
            ></TextField>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Country:
            </label>
            <TextField
              size="small"
              value={user?.country}
              disabled={!isEditing}
              name="country"
              onChange={handleOnChange}
            ></TextField>
          </div>
        </div>

        <div className="">
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Profile Image:
            </label>
            {loading ? (
              <Skeleton variant="circular" width={106} height={106} />
            ) : (
              <Avatar
                alt="profile-image"
                src={user.profileImage || ""}
                sx={{
                  width: 106,
                  height: 106,
                  marginBottom: "5px",
                  border: "1px solid black",
                }}
              />
            )}
            {isEditing && (
              <label htmlFor="featured-image-input">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px solid #A49887",
                    borderRadius: "5px",
                    backgroundColor: "red",
                    color: "white",
                    padding: "2px",
                    cursor: "pointer",
                  }}
                >
                  <input
                    accept="image/*"
                    id="featured-image-input"
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                    disabled={loading}
                  />
                  <Typography variant="contained">Add Image</Typography>
                </div>
              </label>
            )}
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-4 gap-2">
        <Button
          variant="contained"
          color="primary"
          onClick={handleEdit}
          disabled={isEditing}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={!isEditing}
          onClick={handleSubmit}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default Profile;
